import Wrapper from "@/components/layout/wrapper";
import { ConnectionStatus } from "@EspaceParkQC/sdk-call-center";
import { Empty, Spinner } from "@EspaceParkQC/sdk-react";
import { Fragment } from "react";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  children: React.ReactNode;
}

export default function SessionLoader({ children }: Props): React.ReactElement {
  const { t } = useTranslation("main");

  return (
    <ConnectionStatus
      render={({ isOffline, isConnecting }) => {
        if (isConnecting) {
          return (
            <Wrapper className="items-center justify-center gap-4">
              <Spinner className="text-primary" />
              <p className="text-primary">{t("session.connecting-to-sip")}</p>
            </Wrapper>
          );
        }

        if (isOffline) {
          return (
            <Empty>
              <p>
                <Trans
                  i18nKey="session.offline"
                  ns="main"
                  components={{
                    1: <span className="text-destructive font-bold" />,
                  }}
                />
              </p>
            </Empty>
          );
        }

        return <Fragment>{children}</Fragment>;
      }}
    />
  );
}
